<!-- eslint-disable vue/max-attributes-per-line -->
<!--NOTE: 時間ないのでコンポーネントに状態もたせてとりあえずつくっちゃうよ(anti pattern)-->
<template>
  <v-container :key="`eod-closing-${date}`">
    <h1>{{ date }} クロージング</h1>

    <v-menu
      transition="scale-transition"
      min-width="auto"
    >
      <template #activator="{ on, attrs }">
        <v-text-field
          :prepend-icon="icons.mdiCalendar"
          :value="date"
          style="width: fit-content;"
          v-bind="attrs"
          v-on="on"
        >
          <template #append-outer>
            <v-btn
              color="secondary"
              :ripple="false"
              small
              @click="getToday"
            >
              本日
            </v-btn>

            <v-btn
              color="info"
              :ripple="false"
              small
              class="ml-2"
              :to="{ name: 'eod-report', query: { date } }"
            >
              日報
            </v-btn>
          </template>
        </v-text-field>
      </template>

      <v-date-picker
        v-model="date"
        locale="ja"
        :day-format="date => new Date(date).getDate()"
        color="primary"
        :max="isProduction ? today : undefined"
        :min="isPeriodMin ? firstDayOfPreviousMonth() : undefined"
        no-title
      />
    </v-menu>

    <v-stepper
      v-model="step"
      flat
      style="background: none"
    >
      <v-stepper-header>
        <template v-for="(stepper, stepIdx) in steppers">
          <v-stepper-step
            :key="`step-${stepIdx}`"
            :complete="step > stepIdx"
            editable
            :step="stepIdx"
          >
            {{ stepper }}
          </v-stepper-step>
          <v-divider
            v-if="stepIdx < steppers.length - 1"
            :key="`step-divider-${stepIdx}`"
          />
        </template>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="0">
          <AfterJobEditAlert v-show="showAfterJobEditAlert" />
          <v-row>
            <v-col><h2>データセット管理</h2></v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <TimecardsTable :date="date" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <Data :show-date-picker="false" />
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col>
              <v-tabs v-model="tab">
                <v-tab>勤怠</v-tab>
                <v-tab>伝票</v-tab>
                <v-tab>販売履歴</v-tab>
              </v-tabs>

              <v-tabs-items
                v-model="tab"
                touchless
              >
                <v-tab-item>
                  <TimecardsTable :date="date" />
                </v-tab-item>
                <v-tab-item>
                  <TableDetailsTable :date="date" />
                </v-tab-item>
                <v-tab-item>
                  <VendingHistoryDetailsTable :date="date" />
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row> -->
        </v-stepper-content>

        <v-stepper-content step="1" eager>
          <AfterJobEditAlert v-show="showAfterJobEditAlert" />
          <ExpensesTable :date="date" />
        </v-stepper-content>

        <v-stepper-content step="2" eager>
          <v-row>
            <v-col cols="12">
              <Aggregations
                ref="aggregationsComp"
                :date="date"
              />
            </v-col>
          </v-row>
        </v-stepper-content>

        <!-- <v-stepper-content step="3">
          TODO: レジ締め
          流用!! -> tx
        </v-stepper-content> -->

        <v-stepper-content step="3">
          <v-row>
            <v-col cols="12">
              <v-btn
                x-large
                block
                :ripple="false"
                color="primary"
                :to="{ name: 'eod-report', query: { date } }"
              >
                <!-- TODO 完了で抜ける。それ以外はleaveの警告を出す。-->
                完了
              </v-btn>
            </v-col>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
import {
  ref,
  inject,
  onMounted,
  watch,
  computed,
} from '@vue/composition-api'
import { mdiSync, mdiCalendar } from '@mdi/js'
import { useRouter } from '@core/utils'
import { parseISO, isAfter } from 'date-fns'
import { useProcessEnv } from '@/views/v2-temp/common/composables/useProcessEnv'
import { useDateRange } from '@/views/v2-temp/common/composables/useDateRange'
import { useAbilityEvaluate } from '@/views/v2-temp/common/composables/useAbilityEvaluate'
import TimeApi from '@/api/v2/utility/Time'
import Aggregations from './components/Aggregations.vue'
import Data from '@/views/waiter/Data.vue'
import useUserPreferences from '@/views/v2-temp/common/composables/useUserPreferences'
import TimecardsTable from './components/TimecardsTable.vue'
import ExpensesTable from './components/ExpensesTable.vue'
import AfterJobEditAlert from './components/AfterJobEditAlert.vue'

export default {
  components: {
    TimecardsTable,
    ExpensesTable,
    Data,
    Aggregations,
    AfterJobEditAlert,
  },
  setup() {
    const currentClubMeta = inject('currentClubMeta', { today: null })
    const { route, router } = useRouter()
    const { preferences } = useUserPreferences()
    const { isProduction } = useProcessEnv()
    const { firstDayOfPreviousMonth } = useDateRange()
    const { canAccessPeriod } = useAbilityEvaluate()
    const today = currentClubMeta.today || new Date().toISOString().slice(0, 10)
    const date = ref(route.value.query.date || today)
    const step = ref(0)
    const tab = ref(0)
    const fixedAt = ref('')
    const aggregationsComp = ref(null)
    const steppers = [
      'データセット管理',
      '経費管理',
      '日計',
      // 'レジ締め',
      '完了',
    ]

    const neverAfterJobEditWarning = computed(() => preferences.value.eod_closing.neverAfterJobEditWarning)
    const isPast = computed(() => date.value < today)
    const isAllJobMissing = computed(() => aggregationsComp.value?.isAllJobMissing)
    const aggregationsCompIsLoading = computed(() => aggregationsComp.value?.isLoading)
    const showAfterJobEditAlert = computed(() => {
      // ロード後で、警告非表示じゃなくて、ジョブがすべてない場合に限り表示する
      return !aggregationsCompIsLoading.value
        && !neverAfterJobEditWarning.value
        && (!isAllJobMissing.value?.userAggregations || !isAllJobMissing.value?.clubAggregations)
    })
    const isPeriodMin = computed(() => !canAccessPeriod())

    const getToday = async () => {
      const res = await TimeApi.getToday()
      if (res.data.status === 'success') {
        date.value = res.data.data
      }
    }
    const getEndTimeOfDay = async () => {
      const res = await TimeApi.getEndTimeOfDay(date.value)
      if (res.data.status === 'success') {
        fixedAt.value = res.data.data
      }
    }

    watch(() => date.value, newDate => {
      const dateObj = parseISO(newDate)
      const todayObj = parseISO(today)
      if (isProduction && isAfter(dateObj, todayObj)) {
        date.value = today

        return
      }

      router.replace({
        name: route.value.name,
        query: {
          ...route.value.query,
          date: date.value,
        },
      })
    }, { immediate: true })

    onMounted(async () => {
      if (!date.value) await getToday()
      getEndTimeOfDay()
    })

    return {
      step,
      tab,
      date,
      today,
      fixedAt,
      steppers,
      isPast,
      neverAfterJobEditWarning,
      aggregationsComp,
      isAllJobMissing,
      aggregationsCompIsLoading,
      showAfterJobEditAlert,
      getToday,
      isProduction,
      firstDayOfPreviousMonth,
      canAccessPeriod,
      isPeriodMin,
      icons: {
        mdiSync,
        mdiCalendar,
      },
    }
  },
}
</script>

<style lang="scss">
.aggregation-table {
  white-space: nowrap;
}
</style>
